import Rollbar from "rollbar";

const environment = process.env.REACT_APP_ENV || "local";
const appVersion = process.env.REACT_APP_VERSION || "1.0";
const accessToken = process.env.REACT_APP_ROLLBAR_ACCESS_TOKEN || "5ebb8a155f884d4e95a3f70878e7d7f4";

const rollbar = new Rollbar({
  accessToken: accessToken,
  captureUncaught: true,
  captureUnhandledRejections: true,
  enabled: environment === "local" ? false : true,
  environment: environment,
  payload: {
    environment: environment,
    client: {
      javascript: {
        code_version: appVersion,
        source_map_enabled: true,
        guess_uncaught_frames: true,
      },
    },
  },
});

export default rollbar;
